export const hurricaneIcons: Record<string, string> = {
    'chosen-ic1': require('./ic_map_chosen/ic_chosen_1.png'),
    'chosen-ic2': require('./ic_map_chosen/ic_chosen_2.png'),
    'chosen-ic3': require('./ic_map_chosen/ic_chosen_3.png'),
    'chosen-ic4': require('./ic_map_chosen/ic_chosen_4.png'),
    'chosen-ic5': require('./ic_map_chosen/ic_chosen_5.png'),
    'chosen-icTS': require('./ic_map_chosen/ic_chosen_TS.png'),
    'chosen-icTD': require('./ic_map_chosen/ic_chosen_TD.png'),
    'chosen-ic-past1': require('./ic_map_chosen/ic_chosen_past_1.png'),
    'chosen-ic-past2': require('./ic_map_chosen/ic_chosen_past_2.png'),
    'chosen-ic-past3': require('./ic_map_chosen/ic_chosen_past_3.png'),
    'chosen-ic-past4': require('./ic_map_chosen/ic_chosen_past_4.png'),
    'chosen-ic-past5': require('./ic_map_chosen/ic_chosen_past_5.png'),
    'chosen-ic-pastTS': require('./ic_map_chosen/ic_chosen_past_TS.png'),
    'chosen-ic-pastTD': require('./ic_map_chosen/ic_chosen_past_TD.png'),
    'unchosen-ic1': require('./ic_map_unchosen/ic_unchosen_1.png'),
    'unchosen-ic2': require('./ic_map_unchosen/ic_unchosen_2.png'),
    'unchosen-ic3': require('./ic_map_unchosen/ic_unchosen_3.png'),
    'unchosen-ic4': require('./ic_map_unchosen/ic_unchosen_4.png'),
    'unchosen-ic5': require('./ic_map_unchosen/ic_unchosen_5.png'),
    'unchosen-icTS': require('./ic_map_unchosen/ic_unchosen_TS.png'),
    'unchosen-icTD': require('./ic_map_unchosen/ic_unchosen_TD.png'),
    'unchosen-ic-past1': require('./ic_map_unchosen/ic_unchosen_past_1.png'),
    'unchosen-ic-past2': require('./ic_map_unchosen/ic_unchosen_past_2.png'),
    'unchosen-ic-past3': require('./ic_map_unchosen/ic_unchosen_past_3.png'),
    'unchosen-ic-past4': require('./ic_map_unchosen/ic_unchosen_past_4.png'),
    'unchosen-ic-past5': require('./ic_map_unchosen/ic_unchosen_past_5.png'),
    'unchosen-ic-pastTS': require('./ic_map_unchosen/ic_unchosen_past_TS.png'),
    'unchosen-ic-pastTD': require('./ic_map_unchosen/ic_unchosen_past_TD.png'),
    'dialog-ic1': require('./ic_dialog/ic_dialog_1.png'),
    'dialog-ic2': require('./ic_dialog/ic_dialog_2.png'),
    'dialog-ic3': require('./ic_dialog/ic_dialog_3.png'),
    'dialog-ic4': require('./ic_dialog/ic_dialog_4.png'),
    'dialog-ic5': require('./ic_dialog/ic_dialog_5.png'),
    'dialog-icTS': require('./ic_dialog/ic_dialog_TS.png'),
    'dialog-icTD': require('./ic_dialog/ic_dialog_TD.png'),
    'dialog-ic-past1': require('./ic_dialog/ic_dialog_past_1.png'),
    'dialog-ic-past2': require('./ic_dialog/ic_dialog_past_2.png'),
    'dialog-ic-past3': require('./ic_dialog/ic_dialog_past_3.png'),
    'dialog-ic-past4': require('./ic_dialog/ic_dialog_past_4.png'),
    'dialog-ic-past5': require('./ic_dialog/ic_dialog_past_5.png'),
    'dialog-ic-pastTS': require('./ic_dialog/ic_dialog_past_TS.png'),
    'dialog-ic-pastTD': require('./ic_dialog/ic_dialog_past_TD.png'),
    'spotlight-ic1': require('./ic_spotlight/ic_1.png'),
    'spotlight-ic2': require('./ic_spotlight/ic_2.png'),
    'spotlight-ic3': require('./ic_spotlight/ic_3.png'),
    'spotlight-ic4': require('./ic_spotlight/ic_4.png'),
    'spotlight-ic5': require('./ic_spotlight/ic_5.png'),
    'spotlight-icTS': require('./ic_spotlight/ic_TS.png'),
    'spotlight-icTD': require('./ic_spotlight/ic_TD.png')
};

export default hurricaneIcons;
